import { createModel, RematchDispatch } from '@rematch/core';
import { PaginationType } from 'types/common.d';
import { RoleType } from 'types/entities/roles.d';
import * as api from 'services/roles';
import { PermissionType } from 'types/entities/permissions.d';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'rolesEntity';

export const rolesEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof rolesEntity>) => ({
    async load(payload): Promise<{ content: RoleType[] } & PaginationType> {
      try {
        const res = await api.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async findById(payload, state) {
      try {
        const item = state[storeName].ids[payload];
        if (item && !item.isSimplified) {
          return item;
        }
        const res = await api.getById(payload);
        this.saves([res.data]);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await api.deleteById(payload);
        this.remove({ id: payload });
      } catch (e) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        let item;
        if (!payload.id) {
          ({ data: item } = await api.create(payload));
        } else {
          ({ data: item } = await api.update(payload.id, payload));
        }
        this.update(item);
      } catch (e) {
        throw new Error(e);
      }
    },
    async loadPermissions(payload): Promise<{ content: PermissionType[] } & PaginationType> {
      try {
        const res = await api.filterPermissions(payload);
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default rolesEntity;
